export const MAP_STYLES = {
    light: "3ea93b00-b041-44c6-8d68-5a9362ade938",
    dark: "6ecb4f5f-e7e0-4030-9d30-0e71956ccec3",
};

export const getMapStyle = (theme: "light" | "dark"): string => {
    return MAP_STYLES[theme];
};

export const CIRCLE_COLORS = {
    dps: "rgba(99, 177, 255, 0.15)",
    clean: "rgba(204, 232, 0, 0.15)",
    dtp: "rgba(252, 166, 0, 0.15)",
};

export const CIRCLE_CONFIG = {
    radius: 130,
    strokeWidth: 2,
    interactive: false,
};